

exports.__esModule = true;
exports.$OpenButtonModel = undefined;

var _squid = require('squid');

var $OpenButtonModel = exports.$OpenButtonModel = _squid.$Model.extend('$OpenButtonModel', {
    api: new _squid.$Api({
        uri: '/api/openbutton',
        postAttempts: 2,
        cache: true
    })
});

angular.value("$OpenButtonModel", $OpenButtonModel);
_squid.$Model;

_squid.$Api;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-models/src/openButton/index.js
// module id = ../node_modules/xo-models/src/openButton/index.js
// module chunks = 0